import request from '@/utils/request';
//数据源列表
export function dataSourceList(data) {
  return request.post('admin/controls-source/list', data);
}
//数据源添加
export function addDataSource(data) {
  return request.post('admin/controls-source/store', data);
}
//数据源编辑
export function editDataSource(data) {
  return request.post('admin/controls-source/edit', data);
}
//数据源详情
export function dataSourceDetail(data) {
  return request.post('admin/controls-source/detail', data);
}
//数据源删除
export function delDataSource(data) {
  return request.post('admin/controls-source/delete', data);
}
//控件数据源资源
export function controlsSource(data) {
  return request.post('admin/controls/source', data);
}
//控件数据源资源
export function dataSourceInfo(data) {
  return request.post('admin/controls-source/delete/info', data);
}